import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import styles from './QuestionMultiAnswerSlideV4.css';

function QuestionMultiAnswerSlideV4({ question, description, answers, userResponse, submitTemporaryAnswer, id, spriteVersion }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    const handleChange = (userResponseData, answer) => () => {
        if (isPending) return;

        if (userResponseData.answerIds?.includes(answer.id)) {
            submitTemporaryAnswer({ questionId: id, question, answerIds: userResponseData.answerIds.filter(responseId => responseId !== answer.id) });
        } else {
            submitTemporaryAnswer({ questionId: id, question, answerIds: [...(userResponseData.answerIds || []), answer.id] });
        }
    };

    return (
        <div className={styles.form} key={id}>
            <p className={styles.question}>{question}</p>
            {Boolean(description) && <p className={styles.description}>{description}</p>}
            <ul className={styles.answers}>
                {answers.map(answer => {
                    const isChecked = userResponse.answerIds?.length >= 1 ? userResponse.answerIds.includes(answer.id) : false;

                    return (
                        <li key={answer.id} className={styles.answer}>
                            <label className={styles.answerLabel}>
                                <input
                                    type='checkbox'
                                    checked={isChecked}
                                    onChange={handleChange(userResponse, answer)}
                                    className={styles.checkbox}
                                />
                                <span className={styles.answerWrapper}>
                                    {answer.icon && spriteVersion && (
                                        <EmojiIcon name={answer.icon} version={spriteVersion} />
                                    )}
                                    {answer.text}
                                </span>
                                <span
                                    className={styles.answerCheckbox}
                                    aria-hidden='true'
                                >
                                    <Icon name='checked' />
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

QuestionMultiAnswerSlideV4.propTypes = {
    question: PropTypes.string.isRequired,
    description: PropTypes.string,
    answers: PropTypes.array.isRequired,
    userResponse: PropTypes.object,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    spriteVersion: PropTypes.string
};

QuestionMultiAnswerSlideV4.defaultProps = {
    description: '',
    userResponse: {}
};

export {
    QuestionMultiAnswerSlideV4
};
